<template>
  <tr
    :style="{ visibility: collect.isDragging ? 'hidden' : 'visible', opacity: collect.isDragging ? 0.3 : 1 }"
    class="drag-row"
    ref="rowEl"
  >
    <slot />
  </tr>
</template>

<script setup lang="ts">
import { useDrag } from 'vue3-dnd'
import { ref, onMounted } from 'vue'

const props = defineProps<{
  row: { id: number; name: string }
  sourceId: string
}>()

const rowEl = ref<HTMLElement | null>(null)

// useDrag возвращает [collectRef, drag]
const [collect, drag] = useDrag(() => ({
  type: 'ROW',
  item: { row: props.row, sourceId: props.sourceId },
  collect: (monitor) => ({
    isDragging: monitor.isDragging()
  })
}))

onMounted(() => {
  if (rowEl.value) drag(rowEl.value)
})
</script>
